import React, { useState, useEffect, useRef } from 'react';
import './styles.scss';

// Custom hook for scroll animations
const useInView = (options = {}) => {
  const ref = useRef(null);
  const [isInView, setIsInView] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsInView(true);
        if (options.once !== false) {
          observer.unobserve(entry.target);
        }
      } else if (options.once === false) {
        setIsInView(false);
      }
    }, {
      threshold: options.threshold || 0.2,
      rootMargin: options.rootMargin || '0px'
    });

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, []);

  return [ref, isInView];
};

const Amarant = () => {
  // Animation refs
  const [logoRef, logoInView] = useInView({ threshold: 0.5, rootMargin: '-80px 0px' });
  const [textRef, textInView] = useInView({ threshold: 0.3, rootMargin: '-80px 0px' });
  const [ratingsRef, ratingsInView] = useInView({ threshold: 0.5, rootMargin: '-50px 0px' });
  const [phoneRef, phoneInView] = useInView({ threshold: 0.3, rootMargin: '-80px 0px' });

  return (
    <section className="amarant-section">
      <div className="amarant-content">
        <div className="amarant-left">
          <div 
            ref={logoRef}
            className={`amarant-header animate-fade-up ${logoInView ? 'is-visible' : ''}`}
          >
            <img 
              src="/2025/amarant/icons/amarant-logo.svg" 
              alt="Amarant" 
              className="amarant-logo"
            />
          </div>

          <div 
            ref={textRef}
            className={`amarant-text animate-on-scroll ${textInView ? 'is-visible' : ''}`}
          >
            <p className="animate-item">
              Кое най-доброто мобилно приложение в България? Вижте колко човека са дали своите оценки и какви са те.
            </p>
            <p className="animate-item">
              С оценка 4,9 от възможни 5 Амарант продължава да бъде най-добре оцененото мобилно приложение - над 36 хиляди оценки в AppStore & Google Play. Стотици хиляди потребители използват всеки ден най-добрия дигитален партньор за автомобила. Новата година започваме с изключително голям набор от нови и уникални функционалности - за да продължим да бъдем най-доброто приложение във Вашия телефон.
            </p>
          </div>

          <div 
            ref={ratingsRef}
            className={`amarant-ratings animate-stagger-ratings ${ratingsInView ? 'is-visible' : ''}`}
          >
            <a 
              href="https://apps.apple.com/bg/app/amarant/id6477834795" 
              target="_blank" 
              rel="noopener noreferrer"
              className="rating-badge"
            >
              <img 
                src="/2025/amarant/icons/apple-ratings.svg" 
                alt="Download on App Store - 4.9 rating"
              />
            </a>
            <a 
              href="https://play.google.com/store/apps/details?id=com.amarant" 
              target="_blank" 
              rel="noopener noreferrer"
              className="rating-badge"
            >
              <img 
                src="/2025/amarant/icons/google-ratings.svg" 
                alt="Get it on Google Play - 4.9 rating"
              />
            </a>
          </div>
        </div>

        <div 
          ref={phoneRef}
          className={`amarant-right animate-slide-right ${phoneInView ? 'is-visible' : ''}`}
        >
          <div className="amarant-phone">
            <img 
              src="/2025/amarant/images/phoneMockup.png" 
              alt="Amarant app showing Dash Cam feature"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Amarant;
